import { error, warn } from "./logger";
export const CONFIG_ATTRIBUTE = 'data-config'; // Attribute containing the configuration in JSON format.
const VALUE_START = /["{[\-0-9tfn}\]]/; // Characters that can start a JSON value or key after a comma.
function nextNonWhitespace(text, from) {
    let i = from;
    while (i < text.length && /\s/.test(text[i]))
        i++;
    return i;
}
/**
 * Decides whether the `"` at `index` (inside a string) ands the string or is an unescaped quote that beloings to the text.
 * @param text
 * @param index
 * @returns
 */
function isClosingQuote(text, index) {
    const next = nextNonWhitespace(text, index + 1);
    const char = text[next];
    if (char === undefined || char === '}' || char === ']' || char === ':')
        return true;
    if (char === ',') {
        const afterComma = text[nextNonWhitespace(text, next + 1)];
        return afterComma === undefined || VALUE_START.test(afterComma);
    }
    return false;
}
/**
 * Repairs the typical CMS mistakes inside JSON stings:
 * unescape `"` and raw line breaks / tabs.
 * Only used as a fallback when `JSON.parse` fails.
 * @param text
 * @returns
 */
export function escapeInnerQuotes(text) {
    let result = '';
    let inString = false;
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (!inString) {
            if (char === '"')
                inString = true;
            result += char;
            continue;
        }
        if (char === '\\') { // keep exsisting escapes as they are
            result += char + (text[i + 1] ?? '');
            i++;
            continue;
        }
        if (char === '"') {
            if (isClosingQuote(text, i)) {
                inString = false;
                result += char;
            }
            else {
                result += '\\"';
            }
            continue;
        }
        if (char === '\n') {
            result += '\\n';
            continue;
        }
        if (char === '\r') {
            result += '\\r';
            continue;
        }
        if (char === '\t') {
            result += '\\t';
            continue;
        }
        result += char;
    }
    return result;
}
/**
 * Perse the content of `data-config`
 * @param name The name of data attribute
 * @param raw Raw JSOn string
 * @returns not/emtpy Attibute return empty object {}, not valid JSOn retunr null, The error is logged; it is never thrown.
 */
export function parseConfig(name, raw) {
    const trimmed = raw ? raw.trim() : '';
    if (!trimmed)
        return {};
    let parsed;
    try {
        parsed = JSON.parse(trimmed);
    }
    catch (parseError) {
        try {
            parsed = JSON.parse(escapeInnerQuotes(trimmed));
            warn(`[${name}] ${CONFIG_ATTRIBUTE} contained unescaped characters and was repaired`);
        }
        catch {
            error(`[${name}] ${CONFIG_ATTRIBUTE} cannot read`, parseError);
            return null;
        }
    }
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        error(`[${name}] ${CONFIG_ATTRIBUTE} must be a JSON-Objekt`);
        return null;
    }
    return parsed;
}
/**
 * If config added as global object into direct windwo object.
 * @param name
 * @param globalConfigName
 * @returns AppConfiguration object
 */
export function readGlobalConfig(name, globalConfigName) {
    if (!globalConfigName || typeof window === 'undefined')
        return {};
    const raw = window[globalConfigName];
    if (raw === undefined || raw === null)
        return {};
    if (typeof raw !== 'object' || raw === null)
        return {};
    if (typeof raw !== 'object' || Array.isArray(raw)) {
        error(`[${name}] window.${globalConfigName} mus be an object.`);
        return {};
    }
    return raw;
}
/**
 * Assembles the final configuration.
 *
 * @param name The name of data attribute
 * @param el the Container element of data attibute HTML tag.
 * @returns
 */
export function readConfig(name, el, overrides, globalConfigName) {
    const fromAttribute = parseConfig(name, el.getAttribute(CONFIG_ATTRIBUTE));
    if (fromAttribute === null)
        return null;
    return {
        ...readGlobalConfig(name, globalConfigName),
        ...fromAttribute,
        ...overrides
    };
}
